import { post } from '../service/request'

/**
 * 获取智慧党建模块列表（党建活动、学习园地、学习强国）
 * @param {Number} parkType 1 党建活动  2 学习园地 3 学习强国
 * @param {Number}  page 页数
 * @param {Number} limit 每页显示条数
 * @return  {Promise}
 */
export const getZHDJList = (parkType = 1, page = 1, limit = 10) => {
	const params = {
		parktype: parkType,
		page,
		limit,
	}
	return post('/kxZhdj/getZhdjList', params)
}

/**
 * 获取智慧党建模块列表项明细
 * @param {String} id 列表参数id
 * @return {Promise}
 */
export const getZHDJDetailById = (id) => post('/kxZhdj/getDetail', { id })
